import React, { Component } from 'react';
import { Consumer } from "../../context";
import ConceptModalEddit from './conceptModalEddit';
import ModalBorrar from '../modals/modalDelete'
import Request from "../../core/httpClient";
import cogoToast from 'cogo-toast';
import { TreeState, TreeTable } from 'cp-react-tree-table';

const request = new Request();

const rowStyles = ["#f3f4f6", "#fcfcfc", "#ffffff"]; 

class BudgetConceptTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id_concepto: '',
      concepto: '',
      treeValue: TreeState.create(props.treeValue[1]),
      tree_conceptos: props.treeValue[0]
    }
  }

  componentDidMount() {
    this.handleOnExpandAll();
  }

  componentDidUpdate(prevProps) {
    if (this.props.treeValue !== prevProps.treeValue) {
      const rawTreeData = this.props.treeValue[1] || [];
      
      this.setState({
        treeValue: TreeState.create(rawTreeData),
        tree_conceptos: this.props.treeValue[0]
      }, () => {
        // 🛡️ Solo intentamos expandir si la búsqueda arrojó resultados
        if (rawTreeData.length > 0) {
          this.handleOnExpandAll(); 
        }
      });
    }
  }

  recargar() {
    this.props.reload()
  }

  delete = id => {
    this.handleDelete(id)
  }

  openModalDelete() {
    let modal = document.getElementById("deleteModal");
    if (modal) {
      modal.classList.remove('hide-modal');
      modal.classList.add('show-modal');
    }
  }

  render() {
    let conceptos = [];
    if (this.props.conceptos) {
      conceptos = this.props.conceptos
    }
    const { treeValue } = this.state;

    const headerStyleLeft = {
      display: 'flex', alignItems: 'center', width: '100%', height: '100%',
      backgroundColor: '#6d2e87', 
      borderBottom: '2px solid #d1d5db', 
      fontWeight: '600', color: '#f3f4f6', paddingLeft: '15px', boxSizing: 'border-box'
    };

    const headerStyleCenter = {
      display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%',
      backgroundColor: '#6d2e87', borderBottom: '2px solid #d1d5db',
      fontWeight: '600', color: '#f3f4f6', boxSizing: 'border-box'
    };

    return (
      <div className="card-table card-table-budget card-owners column" id="card-owners">
        <div style={{ padding: '0 30px 0 0', width: '100%', boxSizing: 'border-box'}}>
          <div style={{ borderRadius: '8px', overflow: 'hidden', backgroundColor: '#ffffff'
            }}> 
            
            <TreeTable value={treeValue} onChange={this.handleOnChange}>
              
              <TreeTable.Column basis="350px" grow="0" 
                renderCell={this.renderIndexCell}
                renderHeaderCell={() => <div style={headerStyleLeft}>Concepto</div>} 
              />
              
              <TreeTable.Column 
                renderCell={this.renderCuentaContableCell}
                renderHeaderCell={() => <div style={headerStyleCenter}>Cuenta contable</div>} 
              />
              
              <TreeTable.Column
                renderCell={this.renderPresupuestoCell}
                renderHeaderCell={() => <div style={headerStyleCenter}>Mostrar en App</div>} 
              />
              
              <TreeTable.Column 
                renderCell={this.renderActionsCell}
                renderHeaderCell={() => <div style={headerStyleCenter}>Acciones</div>} 
              />
            
            </TreeTable>
          
          </div>
        </div>

        <ConceptModalEddit
          datos={this.state.concepto}
          reload={this.recargar.bind(this)}
          escritura={this.props.escritura}
          tree_conceptos={this.state.tree_conceptos}
        />
        <ModalBorrar id={this.state.id_concepto} delete={this.delete.bind(this)} />

      </div>
    );
  }

  openModalDelete(id) {
    this.setState({ id_concepto: id, id_concepto_row: id });
    let modal = document.getElementById("deleteModal");
    if (modal) {
      modal.classList.remove('hide-modal');
      modal.classList.add('show-modal');
    }
  }

  openModal(idModal, concept) {
    this.setState({ mesagge: null, concepto: concept, id_concepto_row: concept.id_concepto });
    const modal = document.getElementById(idModal);
    if (modal) {
      modal.classList.remove('hide-dinamic-modal');
      modal.classList.add('show-dinamic-modal');
    }
  }

  async handleDelete(id) {
    let data = {
      id_concepto: id,
      id_usuario: this.props.context.user.id.id_usuario
    };

    const response = await request.post("/conceptos/concepto/delete", data);

    if (response && !response.error) {
      if (response.deleted && !response.empty) {
        this.props.reload()
        this.setState({ showModal: false });
        cogoToast.success('Concepto eliminado.', { position: 'bottom-right' });
      } else {
        this.setState({ empty: true });
        cogoToast.error('No se pudo eliminar concepto.', { position: 'bottom-right' });
      }
    } else {
      this.setState({ error: true });
      cogoToast.error('No se pudo eliminar concepto.', { position: 'bottom-right' });
    }
  }

  handleOnChange = (newValue) => {
    this.setState({ treeValue: newValue });
  }

  handleOnExpandAll = () => {
    this.setState((state) => {
      if (!state.treeValue || state.treeValue.length === 0) return null;
      
      try {
        return { treeValue: TreeState.expandAll(state.treeValue) };
      } catch (error) {
        console.warn("TreeTable evitó un colapso interno: ", error);
        return null;
      }
    });
  }

  handleOnCollapseAll = () => {
    this.setState((state) => {
      return { treeValue: TreeState.collapseAll(state.treeValue) };
    });
  }

  renderIndexCell = (row) => {
    if (!row || !row.$state || !row.data || !row.data[0]) return null;
    return (
      <div style={{ 
        paddingLeft: 15 + (row.metadata.depth * 25) + 'px', // Indentación más clara
        background: rowStyles[row.metadata.depth], 
        position: 'absolute', top: 0, bottom: 0, left: 0, right: 0,
        display: 'flex', alignItems: 'center', 
        borderBottom: '1px solid #e5e7eb',  
        boxSizing: 'border-box'
      }}>
        <button className={`toggle-button ${row.$state.isExpanded ? 'expanded' : ''}`}
          onClick={row.toggleChildren}
          disabled={!row.metadata.hasChildren}
          style={{ background: 'transparent', border: 'none', display: 'flex', alignItems: 'center', gap: '8px', cursor: row.metadata.hasChildren ? 'pointer' : 'default', color: 'inherit', fontWeight: row.metadata.depth === 0 || row.metadata.depth === 1 ? '600' : '400', color: row.metadata.depth === 0 ? '#374151' : '#4b5563' }}>
          {row.data[0].nombre}
        </button>
      </div>
    );
  }

  renderCuentaContableCell = (row) => {
    if (!row || !row.$state || !row.data || !row.data[0]) return null;
    return (
      <div style={{ 
        background: rowStyles[row.metadata.depth], 
        position: 'absolute', top: 0, bottom: 0, left: 0, right: 0,
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        borderBottom: '1px solid #e5e7eb',
        color: '#4b5563',
        boxSizing: 'border-box'
      }}>
        <span>{row.data[0].cuenta_contable || "-"}</span>
      </div>
    );
  }

  renderPresupuestoCell = (row) => {
    if (!row || !row.$state || !row.data || !row.data[0]) return null;
    return (
      <div style={{ 
        background: rowStyles[row.metadata.depth], 
        position: 'absolute', top: 0, bottom: 0, left: 0, right: 0,
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        borderBottom: '1px solid #e5e7eb',
        color: '#4b5563',
        boxSizing: 'border-box'
      }}>
        <span>{row.data[0].mostrar_app === 1 ? <i className="fas fa-check text-green-600" style={{color: '#10b981'}} /> : <i className="fas fa-times text-red-500" style={{color: '#ef4444'}} />}</span>
      </div>
    );
  }

  renderActionsCell = (row) => {
    if (!row || !row.$state || !row.data || !row.data[0]) return null;
    return (
      <div style={{ 
        background: rowStyles[row.metadata.depth], 
        position: 'absolute', top: 0, bottom: 0, left: 0, right: 0,
        borderBottom: '1px solid #e5e7eb',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxSizing: 'border-box'
      }}>
        <div style={{ display: 'flex', gap: '6px' }}>
          <button 
            className="justify-center btn-mini btn-secondary color-white" 
            type="button"
            onClick={this.on_showEditDialog.bind(this, row)} 
          >
            <i className="font-small fas fa-pen" />
          </button>
          
          <button 
            className="justify-center btn-mini btn-secondary color-white"
            type="button"
            onClick={this.on_showDeleteDialog.bind(this, row)}
            disabled={!this.props.escritura}
          >
            <i className="font-text fas fa-trash-alt" />
          </button>
        </div>
      </div>
    );
  }

  on_showDeleteDialog(row) {
    if (row.metadata.hasChildren === false) {
      this.openModalDelete(row.data[0].id_concepto);
    } else {
      cogoToast.error('No se puede eliminar este concepto. Tiene dependencias ', {
        position: 'bottom-right',
      });
    }
  }

  on_showEditDialog(row) {
    let concepto = {
      id_concepto: row.data[0].id_concepto,
      id_parent: row.data[0].id_parent,
      nombre: row.data[0].nombre,
      mostrar_app: row.data[0].mostrar_app,
      cuenta_contable: row.data[0].cuenta_contable
    };
    this.openModal("editBudget", concepto);
  }
}

export default Consumer(BudgetConceptTable);